import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { MapPin, Phone, Mail, MessageCircle } from 'lucide-react';
import './ContactSection.css';

const ContactSection = () => {
  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    setTimeout(() => setFormSubmitted(false), 3000);
  };

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/+447304083286', '_blank');
  };

  return (
    <section id="contact" className="contact">
      <motion.div
        className="contact-header"
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: 'easeOut' }}
        viewport={{ once: true }}
      >
        <h2 className="contact-heading">Contact NIRUPRINT SOLUTIONS</h2>
        <p className="contact-subheading">
          Get in touch for custom printing and binding inquiries.
        </p>
      </motion.div>
      <div className="contact-container">
        <motion.div
          className="contact-content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <div className="contact-info">
            <h3 className="contact-info-title">Our Details</h3>
            <div className="contact-info-item">
              <MapPin className="contact-icon" size={24} />
              <span>UNIT H2C, Deseronto Estate, St. Mary Road, Slough, Berkshire, SL3 7EW</span>
            </div>
            <div className="contact-info-item">
              <Phone className="contact-icon" size={24} />
              <a href="tel:+447304083286">07304 083286</a>
            </div>
            <div className="contact-info-item">
              <Mail className="contact-icon" size={24} />
              <a href="mailto:nirupal92@gmail.com">nirupal92@gmail.com</a>
            </div>
            <iframe
              className="contact-map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.5876271590727!2d-0.501943484229394!3d51.51974127963833!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487669f6c3f3c7f9%3A0x7c0f6b8b8b8b8b8b!2sDeseronto%20Estate%2C%20St%20Marys%20Rd%2C%20Slough%2C%20UK!5e0!3m2!1sen!2sus!4v1697051234567!5m2!1sen!2sus"
              width="100%"
              height="300"
              style={{ border: 0, borderRadius: '12px' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="NIRUPRINT SOLUTIONS Location"
            />
          </div>
          <div className="contact-form-container">
            <h3 className="contact-form-title">Send Us a Message</h3>
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name" className="form-label">Name</label>
                <input
                  type="text"
                  id="name"
                  className="form-input"
                  placeholder="Your Name"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="email" className="form-label">Email</label>
                <input
                  type="email"
                  id="email"
                  className="form-input"
                  placeholder="Your Email"
                  required
                />
              </div>
              <div className="form-group">
                <label htmlFor="message" className="form-label">Message</label>
                <textarea
                  id="message"
                  className="form-input form-textarea"
                  placeholder="Your Enquiry"
                  required
                />
              </div>
              <motion.button
                type="submit"
                className="form-submit"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Send Message
              </motion.button>
              {formSubmitted && (
                <motion.p
                  className="form-success"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  Message sent! We'll get back to you soon.
                </motion.p>
              )}
            </form>
          </div>
        </motion.div>
        <motion.button
          className="whatsapp-btn"
          onClick={handleWhatsAppClick}
          whileHover={{ scale: 1.1 }}
          whileTap={{ scale: 0.9 }}
          initial={{ opacity: 0, x: 50 }}
          whileInView={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.6, delay: 0.6 }}
          viewport={{ once: true }}
        >
          <MessageCircle size={24} />
          Chat on WhatsApp
        </motion.button>
      </div>
    </section>
  );
};

export default ContactSection;